module.exports = function scrollAnimation(scrollTargetElement, duration) {
  const targetOffset = scrollTargetElement.offsetTop;
  const currentScroll = window.pageYOffset;
  const scrollBy = targetOffset - currentScroll;
  const step = scrollBy / (duration / 15);

  const scroll = setInterval(() => {
    const { pageYOffset, innerHeight } = window;

    const targetReached = pageYOffset >= targetOffset;
    const bottomReached = (innerHeight + pageYOffset) >= document.body.offsetHeight - 2;

    if (!targetReached && !bottomReached) {
      window.scrollBy(0, step);
    } else {
      clearInterval(scroll);
    }
  }, 15);
};
